import type { CauseAdvocateFormData } from "./causeList.types";

export const getCauseAdvocates = (cause: any): CauseAdvocateFormData[] => {
  const advocates = Array.isArray(cause?.advocates)
    ? cause.advocates
        .map((advocate: any) => ({
          name: advocate?.name || "",
          type:
            advocate?.type === "respondent" ? "respondent" : "petitioner",
          enrollment: advocate?.enrollment || "",
          userId:
            typeof advocate?.userId === "object"
              ? advocate.userId?._id
              : advocate?.userId || "",
          lockedEnrollment: Boolean(advocate?.userId),
        }))
        .filter((advocate: CauseAdvocateFormData) => advocate.name)
    : [];

  if (advocates.length) return advocates;

  return [
    {
      name: cause?.advocatePetitioner || "",
      type: "petitioner",
      enrollment: cause?.petitionerEnrollmentId || "",
    },
    {
      name: cause?.advocateRespondent || "",
      type: "respondent",
      enrollment: cause?.respondentEnrollmentId || "",
    },
  ];
};

export const syncLegacyAdvocateFields = <T extends Record<string, any>>(
  payload: T,
) => {
  const advocates = Array.isArray(payload.advocates)
    ? payload.advocates
        .map((advocate: any) => ({
          name: String(advocate?.name || "").trim(),
          type:
            advocate?.type === "respondent" ? "respondent" : "petitioner",
          enrollment: String(advocate?.enrollment || "").trim(),
          userId: advocate?.userId || undefined,
        }))
        .filter((advocate: any) => advocate.name)
    : [];

  const petitionerAdvocate = advocates.find(
    (advocate: any) => advocate.type === "petitioner",
  );
  const respondentAdvocate = advocates.find(
    (advocate: any) => advocate.type === "respondent",
  );

  return {
    ...payload,
    advocates,
    advocatePetitioner:
      petitionerAdvocate?.name || payload.advocatePetitioner || "",
    petitionerEnrollmentId:
      petitionerAdvocate?.enrollment || payload.petitionerEnrollmentId || "",
    advocateRespondent:
      respondentAdvocate?.name || payload.advocateRespondent || "",
    respondentEnrollmentId:
      respondentAdvocate?.enrollment || payload.respondentEnrollmentId || "",
  };
};

export const formatAdvocatesByType = (
  cause: any,
  type: "petitioner" | "respondent",
) => {
  const advocates = getCauseAdvocates(cause).filter(
    (advocate) => advocate.type === type && advocate.name,
  );

  if (!advocates.length) return "N/A";

  return advocates
    .map((advocate) =>
      advocate.enrollment
        ? `${advocate.name} (${advocate.enrollment})`
        : advocate.name,
    )
    .join(", ");
};
